module.exports = __webpack_public_path__ + "static/img/yk9400.c5e0d8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hardware/yk9400.png
// module id = ihbh
// module chunks = 1